const mutations = {
    setTrackAndTrace(state, payload) {
        state = payload;
    },
};

export default mutations